import { EntityId } from "@reduxjs/toolkit";
import { LiveStreamingState } from "./state";

export const getSiteDeviceSelectionBySiteId = (
    state: LiveStreamingState,
    siteId: EntityId,
) => state.siteDeviceSelections?.find((x) => x.siteId === siteId);
